import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';
import { latestUploadsByGenre, genreTabs } from '../mock';
import { usePlayer } from '../context/PlayerContext';

const LatestUploads = () => {
  const [active, setActive] = useState('Reggaeton');
  const { current, isPlaying, play, togglePlay } = usePlayer();
  const items = latestUploadsByGenre[active] || [];

  return (
    <section className="px-6 mt-12 mb-10">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-display text-2xl md:text-3xl text-white">Latest Uploads</h2>
        <button className="text-xs uppercase tracking-wider text-neutral-400 hover:text-white transition-colors">See all</button>
      </div>

      {/* Genre tabs */}
      <div className="no-scrollbar overflow-x-auto">
        <div className="flex items-center gap-6 pb-3 border-b border-white/5 min-w-max">
          {genreTabs.map((t) => {
            const isActive = t === active;
            const isDisabled = !latestUploadsByGenre[t];
            let tabColorClass;
            if (isActive) {
              tabColorClass = 'text-white active';
            } else if (isDisabled) {
              tabColorClass = 'text-neutral-600';
            } else {
              tabColorClass = 'text-neutral-400 hover:text-white';
            }
            return (
              <button
                key={t}
                onClick={() => !isDisabled && setActive(t)}
                className={`tab-underline text-sm whitespace-nowrap transition-colors ${tabColorClass}`}
              >
                {t}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2">
        {items.map((track, idx) => {
          const activeTrack = current?.id === track.id && isPlaying;
          const onClick = () => (current?.id === track.id ? togglePlay() : play(track));
          return (
            <div
              key={track.id}
              className="group flex items-center gap-4 p-2 rounded-lg hover:bg-white/[0.04] transition-colors cursor-pointer"
              onClick={onClick}
            >
              <div className="w-6 text-neutral-500 text-sm text-right group-hover:hidden">{idx + 1}</div>
              <button className="w-6 hidden group-hover:flex items-center justify-center text-white">
                {activeTrack ? <Pause className="w-4 h-4" fill="currentColor" /> : <Play className="w-4 h-4" fill="currentColor" />}
              </button>
              <div className="relative w-12 h-12 rounded overflow-hidden flex-shrink-0">
                <img src={track.cover} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-white line-clamp-1">{track.title}</div>
                <div className="text-xs text-neutral-400 line-clamp-1">{track.artist}</div>
              </div>
              <div className="text-xs text-neutral-500 flex-shrink-0">{track.duration}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LatestUploads;
